import { createReducer, on } from "@ngrx/store";
import { TransactionFormServiceError } from "../../create-request/models/form/TransactionForm";
import { SharedActions } from "../actions";

export const serviceErrorKey = 'serviceErrors';

export type State = {
    [serviceCallName: string]: TransactionFormServiceError
};

export const initialTransactionFormServiceError: State = {

}

export const serviceErrorReducer = createReducer(
    initialTransactionFormServiceError,
    on(SharedActions.updateCorrelationId, (state, { correlationId, serviceCallUrl }) => {
        return {
            ...state,
            [serviceCallUrl]: {
                ...state[serviceCallUrl],
                correlationId: correlationId,
                url: serviceCallUrl,
            }
        }
    }),
)